import randomcolor from "randomcolor";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { Typography } from "@mui/material";
import { withStyles } from "@mui/styles";

import Card from "@mui/material/Card/Card";
import CardContent from "@mui/material/CardContent";
import { statisticsStyles } from "components/statistics/styles";
import { ACTION_STATES } from "core/actions";
import PropTypes from "prop-types";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, count, name } = props;

    // eslint-disable-next-line
    const radius = 25 + innerRadius + (outerRadius - innerRadius);
    // eslint-disable-next-line
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    // eslint-disable-next-line
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="#000000" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
            {`${name}: ${count}`}
        </text>
    );
};

class TagsChart extends PureComponent {
    getColor = () => {
        return randomcolor({
            hue: "random",
            alpha: 0.8,
        });
    };
    render() {
        const { classes, tagsQueryStatus, data } = this.props;

        const noData = tagsQueryStatus === ACTION_STATES.SUCCESS && data.length === 0;
        const chart = !noData ? (
            <ResponsiveContainer>
                <PieChart width={600} height={600}>
                    <Pie
                        data={data}
                        cx={300}
                        cy={230}
                        label={renderCustomizedLabel}
                        outerRadius={150}
                        fill="#8884d8"
                        dataKey="count"
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.tagColor === "#000000" ? this.getColor() : entry.tagColor}
                            />
                        ))}
                    </Pie>
                    <Tooltip isAnimationActive={false} />
                    <Legend layout={"horizontal"} align={"left"} verticalAlign={"top"} />
                </PieChart>
            </ResponsiveContainer>
        ) : (
            <Card>
                <CardContent>
                    <Typography variant="h6">There is no data for this search criteria</Typography>
                </CardContent>
            </Card>
        );
        return <div className={classes.responsiveTagChart}>{chart}</div>;
    }
}

TagsChart.propTypes = {
    classes: PropTypes.object.isRequired,
    tagsQueryStatus: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
};

export default connect(({ statistics }) => ({
    tags: statistics.tags,
    data: statistics.tagsData,
    tagsQueryStatus: statistics.tagsQueryStatus,
}))(withStyles(statisticsStyles)(TagsChart));
